export const PKCE_VERIFIER_KEY = "sso_pkce_code_verifier";
export const PKCE_STATE_KEY = "sso_pkce_state";

function toBase64Url(bytes: Uint8Array): string {
	let binary = "";
	bytes.forEach((byte) => {
		binary += String.fromCharCode(byte);
	});

	return btoa(binary).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

function randomBase64Url(byteLength: number): string {
	return toBase64Url(crypto.getRandomValues(new Uint8Array(byteLength)));
}

export function generateCodeVerifier(): string {
	return randomBase64Url(64);
}

export function generateState(): string {
	return randomBase64Url(32);
}

export async function deriveCodeChallenge(verifier: string): Promise<string> {
	const digest = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(verifier));

	return toBase64Url(new Uint8Array(digest));
}
